import Cookies from "js-cookie";
import { useEffect } from "react";
import EditIcon from '@mui/icons-material/Edit';
import DetailsTag from "./DetailsTag";
import { getRdRentalAddressByTenantId } from "../../../services/BillingAddress";
import useTenant from "../../../components/hooks/useTenant";

type BillingAddressProps = {
  setShowPopupUpdateBillingAddress: (value: boolean) => void;
  billingAddressData: any;
  setBillingAddressData: (value: any) => void;
}

const BillingAddress = ({
  setShowPopupUpdateBillingAddress,
  billingAddressData,
  setBillingAddressData
}: BillingAddressProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { handleTenantError }: any = useTenant();

  useEffect(() => {
    if (tenantId) {
      getRdRentalAddressByTenantId(tenantId)
        .then(res => {
          setBillingAddressData(res);
          handleTenantError(null);
        })
        .catch(error => {       
          handleTenantError(error);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId])

  const editTheBillingAddress = () => {
    setShowPopupUpdateBillingAddress(true);
  }

  return (
    <div className="w-full border border-[#167AC3] rounded-lg">
      <div className="flex justify-between items-center w-full h-[50px] px-4 py-2 bg-[#167AC3] text-white rounded-tl-lg rounded-tr-lg">
        <h4 className="font-medium text-white">Billing Address</h4>

        <EditIcon
          className="cursor-pointer"
          onClick={editTheBillingAddress}
        />
      </div>

      <div className="flex flex-col p-4 gap-3">
        <DetailsTag title="Company Name" value={billingAddressData?.name} />

        <div className="flex gap-4">
          <DetailsTag title="Email" value={billingAddressData?.emailAddress} />
          <DetailsTag title="Phone Number" value={billingAddressData?.phoneNumber} />
        </div>

        <div className="flex gap-4">
          <DetailsTag title="Street" value={billingAddressData?.street} />
          <DetailsTag title="Street 2" value={billingAddressData?.street2} />
          <DetailsTag title="ZIP" value={billingAddressData?.zip} />
        </div>

        <div className="flex gap-4">
          <DetailsTag title="State" value="TX" />
          <DetailsTag title="City" value={billingAddressData?.city} />
          <DetailsTag title="Country" value={billingAddressData?.country} />
        </div>
      </div>
    </div>
  );
}

export default BillingAddress;